export default "/images/vendor/@coreui/icons/svg/flag/cif-sa.svg?c8392ce4e58c853a769d5f3ff55bb640";